export default __webpack_public_path__ + "static/media/woman-holding-ipad.994c24fe.png";